/**
 * Where "Request a demo" on the public landing page points (PublicV2).
 *
 * Overridable at build time with REACT_APP_DEMO_CONTACT_EMAIL; this is the
 * default when that is unset or blank.
 *
 * TODO before production: confirm the ironsight.com domain and that this
 * mailbox exists and is monitored. Not yet confirmed (decided 08.10.2026).
 */
export const DEFAULT_DEMO_CONTACT_EMAIL = 'sales@ironsight.com';

export const DEMO_CONTACT_ENV = 'REACT_APP_DEMO_CONTACT_EMAIL';

/** The demo contact address, or null when there is none to show. */
export function demoContactEmail(env = process.env, fallback = DEFAULT_DEMO_CONTACT_EMAIL) {
    const value = (env[DEMO_CONTACT_ENV] || '').trim();
    return value || (fallback || '').trim() || null;
}
